module.exports = __webpack_public_path__ + "img/doota.4a171ed3.jpg";